import api from '../api';

export const userService = {

    getUserData: async (userId) => {
        try {
            const response = await api.get(`/user/data/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teachers quizzes:', error);
            throw error;
        }
    }
}